import React, { useEffect, useState, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { setInterval, clearInterval } from 'worker-timers';
import pusher from '../../utils/pusher';

const PageReloadContainer = styled.div`
    padding: 10px;
    background: #ffda89;
    color: #666;
    z-index: 99999;
    width: 100%;
    text-align: center;
    margin-bottom: 15px;

    @media(max-width: 767px) {
        width: 100%;
    }
`;

const PageReload = () => {
    const [show, setShow] = useState(false);
    const [loggedInUserId, setLoggedInUserId] = useState('');
    const [checkInterval, setCheckInterval] = useState('');
    const [isChecking, setIsChecking] = useState(false);
    const [message, setMessage] = useState(null);

    const subscribeToPageReload = () => {
        const channel = pusher.subscribe(`page-reload`);
        channel.bind('App\\Events\\PageReloadEvent', (d) => {
            handleNotificationEvent(d);
        });
    };

    const handleNotificationEvent = (response) => {
        console.log("🚀 ~ handleNotificationEvent ~ response:", response);
        setShow(response.data);
        localStorage.setItem('page-reload', response.data);
        setMessage(response.message);
    };

    const checkReload = async () => {
        setIsChecking(true);
        await axios.get(`/api/users/${loggedInUserId}`, {
            params: {
                only: 'wdt'
            }
        }).then(response => {
            const wdt = response.data.wdt;

            if (wdt) {
                setShow(true);
            }

            setIsChecking(false);
        });
    };

    const handlePageReload = async () => {
        await axios.patch(`/api/users/${loggedInUserId}`, {
            wdt: false
        })
            .then(response => {
                localStorage.removeItem('page-reload');
                window.location.reload(true);
            });
    };

    useEffect(() => {
        const showStatus = localStorage.getItem('page-reload') ? true : false;
        setShow(showStatus);
        subscribeToPageReload();
    }, []);

    useEffect(() => {
        const userId = localStorage.getItem('loggedin_user');
        setLoggedInUserId(userId);
    }, []);

    useEffect(() => {
        let interval = null;
        if (!checkInterval && loggedInUserId) {
            const time = process.env.APP_ENV === 'production' ? 3600000 : 300000;

            interval = setInterval(() => {
                if (!isChecking) {
                    checkReload();
                }
            }, time);

            setCheckInterval(interval);
        }

        return () => {
            if (checkInterval) {
                clearInterval(checkInterval);
            }
        };
    }, [loggedInUserId]);

    return <React.Fragment>
        {
            show ? <PageReloadContainer className="page-reload">
                {
                    message ?? 'Your page needs to be updated, please click here to refresh your browser'
                }
                <button
                    type="button"
                    className="btn btn-primary ml-3"
                    onClick={handlePageReload}
                >Update</button>
            </PageReloadContainer>
                : null
        }
    </React.Fragment>;
};

export default PageReload;